module.exports = __webpack_public_path__ + "media/images/icon__paginationArrows@3x-c6b2059c9a1475c56853a114e270157e.png";